import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'ko',
  Pagination: {
    items_per_page: '/ 쪽',
    jump_to: '이동하기',
    jump_to_confirm: '확인하다',
    page: '',
    prev_page: '이전 페이지',
    next_page: '다음 페이지',
    prev_5: '이전 5 페이지',
    next_5: '다음 5 페이지',
    prev_3: '이전 3 페이지',
    next_3: '다음 3 페이지',
  },
  DatePicker: {
    lang: {
      placeholder: '날짜 선택',
      rangePlaceholder: [
        '시작일',
        '종료일',
      ],
      locale: 'ko_KR',
      today: '오늘',
      now: '현재 시각',
      backToToday: '오늘로 돌아가기',
      ok: '확인',
      clear: '지우기',
      month: '월',
      year: '년',
      timeSelect: '시간 선택',
      dateSelect: '날짜 선택',
      monthSelect: '달 선택',
      yearSelect: '연 선택',
      decadeSelect: '연대 선택',
      yearFormat: 'YYYY년',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'Do',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: '이전 달 (PageUp)',
      nextMonth: '다음 달 (PageDown)',
      previousYear: '이전 해 (Control + left)',
      nextYear: '다음 해 (Control + right)',
      previousDecade: '이전 연대',
      nextDecade: '다음 연대',
      previousCentury: '이전 세기',
      nextCentury: '다음 세기',
    },
    timePickerLocale: {
      placeholder: '시간 선택',
      rangePlaceholder: [
        '시작 시간',
        '종료 시간',
      ],
    },
  },
  TimePicker: {
    placeholder: '시간 선택',
    rangePlaceholder: [
      '시작 시간',
      '종료 시간',
    ],
  },
  Calendar: {
    lang: {
      placeholder: '날짜 선택',
      rangePlaceholder: [
        '시작일',
        '종료일',
      ],
      locale: 'ko_KR',
      today: '오늘',
      now: '현재 시각',
      backToToday: '오늘로 돌아가기',
      ok: '확인',
      clear: '지우기',
      month: '월',
      year: '년',
      timeSelect: '시간 선택',
      dateSelect: '날짜 선택',
      monthSelect: '달 선택',
      yearSelect: '연 선택',
      decadeSelect: '연대 선택',
      yearFormat: 'YYYY년',
      dateFormat: 'YYYY-MM-DD',
      dayFormat: 'Do',
      dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
      monthBeforeYear: false,
      previousMonth: '이전 달 (PageUp)',
      nextMonth: '다음 달 (PageDown)',
      previousYear: '이전 해 (Control + left)',
      nextYear: '다음 해 (Control + right)',
      previousDecade: '이전 연대',
      nextDecade: '다음 연대',
      previousCentury: '이전 세기',
      nextCentury: '다음 세기',
    },
    timePickerLocale: {
      placeholder: '시간 선택',
      rangePlaceholder: [
        '시작 시간',
        '종료 시간',
      ],
    },
  },
  Table: {
    filterTitle: '필터 메뉴',
    filterConfirm: '확인',
    filterReset: '초기화',
    filterEmptyText: '필터 없음',
    emptyText: '데이터 없음',
    selectAll: '모두 선택',
    selectInvert: '선택 반전',
  },
  Modal: {
    okText: '확인',
    cancelText: '취소',
    justOkText: '확인',
  },
  Popconfirm: {
    okText: '확인',
    cancelText: '취소',
  },
  Transfer: {
    searchPlaceholder: '여기에 검색하세요',
    itemUnit: '개',
    itemsUnit: '개',
  },
  Upload: {
    uploading: '업로드 중...',
    removeFile: '파일 삭제',
    uploadError: '업로드 실패',
    previewFile: '파일 미리보기',
    downloadFile: '파일 다운로드',
  },
  Empty: {
    description: '데이터 없음',
  },
  Form: {
    defaultValidateMessages: {
      default: '필드 유효성 검사 오류 ${label}',
      required: '${label} 입력해 주세요',
      enum: '${label} [${enum}] 중에 하나여야 합니다',
      whitespace: '${label} 비워둘 수 없습니다',
      date: {
        format: '${label} 유효하지 않은 날짜 형식입니다',
        parse: '${label} 날짜 형식으로 변환될 수 없습니다',
        invalid: '${label} 유효하지 않은 날짜입니다',
      },
      types: {
        string: '${label} 유효하지 않은 ${type}',
        method: '${label} 유효하지 않은 ${type}',
        array: '${label} 유효하지 않은 ${type}',
        object: '${label} 유효하지 않은 ${type}',
        number: '${label} 유효하지 않은 ${type}',
        date: '${label} 유효하지 않은 ${type}',
        boolean: '${label} 유효하지 않은 ${type}',
        integer: '${label} 유효하지 않은 ${type}',
        float: '${label} 유효하지 않은 ${type}',
        regexp: '${label} 유효하지 않은 ${type}',
        email: '${label} 유효하지 않은 ${type}',
        url: '${label} 유효하지 않은 ${type}',
        hex: '${label} 유효하지 않은 ${type}',
      },
      string: {
        len: '${label} ${len}글자여야 합니다',
        min: '${label} 적어도 ${min}글자 이상이어야 합니다',
        max: '${label} ${max}글자 이하여야 합니다',
        range: '${label} ${min}-${max}글자 사이어야 합니다',
      },
      number: {
        len: '${label} 값은 ${len}이어야 합니다',
        min: '${label} 최솟값은 ${min}입니다',
        max: '${label} 최댓값은 ${max}입니다',
        range: '${label} 값은 ${min}-${max} 사이어야 합니다',
      },
      array: {
        len: '${len}이어야 합니다 ${label} ',
        min: '최소 ${min}이어야 합니다 ${label}',
        max: '최대 ${max}이어야 합니다 ${label}',
        range: '${label} ${min}-${max} 사이어야 합니다',
      },
      pattern: {
        mismatch: '${label} ${pattern} 패턴과 일치하지 않습니다',
      },
    },
  },
};

export default localeValues;
